import classNames, { Argument } from 'classnames';
import React from 'react';

export interface ZenErrorMessageProps {
    message: string;
    className?: Argument[];
}

const ZenErrorMessage = ({ message, className }: ZenErrorMessageProps) => {
    return <small className={classNames(className, `mt-6 text-error`)}>{message}</small>;
};

export default ZenErrorMessage;
